import { useEffect, useRef, useState } from "react";
import classes from "./MonthlyTripCards.module.css";
import TripCards from "../../../Global/Cards/TripCards";
import NewTripCards from "../../../Global/Cards/newTripCards";

const MonthlyTripCards = ({
  tripData,
  monthName,
  selectedMonth,
  selectedCategory,
}) => {
  const monthShortRef = useRef(null);
  const [trip, setTrip] = useState(tripData);

  useEffect(() => {
    if (selectedMonth !== "" && monthName.includes(selectedMonth)) {
      monthShortRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  }, [selectedMonth, monthName]);

  useEffect(() => {
    if (selectedCategory === "" || selectedCategory === "All")
      setTrip(tripData);
    else {
      var tr = [];
      setTrip(() => {
        tr= tripData.filter((tr) =>
          tr.tripCategory.includes(selectedCategory)
        );
        if(tr.length==0)tr=tripData;
        return tr;
      });
    }
  }, [selectedCategory]);

  return (
    <>
      {trip.length > 0 && (
        <div className={classes["month-container"]} ref={monthShortRef}>
          <p className={classes["month-name"]}>{monthName}</p>
          <p className={classes["underline"]}>______</p>
          {/* <div className={classes['mobile-filter-month']}>
                <Dropdown tripDataHandler={tripDataHandler} options={dropdownOptions} plc={'Select Category'} />
            </div>
            <div className={classes['month-dropdown-adjust']}>
                <Dropdown tripDataHandler={tripDataHandler} options={dropdownOptions} plc={'Select Category'} />
            </div> */}
          {trip.length > 0 && (
            <NewTripCards tripData={trip} monthName={monthName} />
          )}
        </div>
      )
    }
    </>
  );
};

export default MonthlyTripCards;
